import { useParams } from "react-router-dom";

const POLICIES = {
  privacy: {
    title: "Privacy Policy",
    body: [
      "At Naathi Charami Gifts & Hampers (founded by Monalika Reddy), we respect and protect the privacy of our customers. This Privacy Policy describes the information we collect, how we use it, and the steps we take to keep it safe.",
      "Information we collect: Name, email, phone number, billing/shipping address, and order details when you make a purchase or inquiry.",
      "How we use it: To fulfil and deliver orders, send order updates via WhatsApp/email, respond to inquiries, and improve our services.",
      "Sharing: We do not sell or rent your personal information. We share limited information only with logistics partners and payment gateways (Razorpay) to process your order.",
      "Cookies: Our website may use cookies to improve user experience and analyze traffic.",
      "Your rights: You may request access, correction, or deletion of your personal data by writing to naathicharami23@gmail.com.",
      "Updates: This policy may be updated periodically. Continued use of our services indicates acceptance of the latest version.",
    ],
  },
  shipping: {
    title: "Shipping Policy",
    body: [
      "Naathi Charami Gifts & Hampers (founded by Monalika Reddy) currently ships across Hyderabad with same-day or next-day delivery for in-stock items, and pan-India delivery via partnered courier services.",
      "Order processing: Orders placed before 2 PM IST are typically dispatched the same business day. Customized hampers may take 2–5 additional working days.",
      "Delivery time: Hyderabad — Same / next day. Other major cities — 3–5 business days. Remote areas — 5–8 business days.",
      "Shipping charges: Calculated based on order weight and delivery pincode. Displayed before final checkout.",
      "Tracking: Once dispatched, a tracking link/number will be shared via WhatsApp or email.",
      "Damaged or undelivered shipments: Please notify us within 24 hours of delivery with photos for prompt resolution.",
    ],
  },
  return: {
    title: "Return & Refund Policy",
    body: [
      "Naathi Charami Gifts & Hampers (founded by Monalika Reddy) takes great care in curating every hamper. Because our products are perishable, personalized and/or hand-assembled, we follow a limited return policy:",
      "Damaged on arrival: If your hamper arrives damaged, please share photographs and order details on WhatsApp (+91 93460 42323) or email within 24 hours of delivery. We will replace the affected item(s) or issue a refund at our discretion.",
      "Wrong product: If you receive an incorrect product, please notify us within 24 hours. We will arrange pickup and dispatch the correct item.",
      "Non-returnable items: Personalized hampers, edible items, perishables, and customized orders are non-returnable unless damaged.",
      "Refunds: Approved refunds are processed within 7–10 business days via the original payment method.",
      "Cancellations: Orders may be cancelled before dispatch by contacting us on WhatsApp. Once dispatched, cancellations are not possible.",
    ],
  },
  terms: {
    title: "Terms & Conditions",
    body: [
      "Welcome to Naathi Charami Gifts & Hampers, founded by Monalika Reddy. By accessing or using our website you agree to be bound by these Terms & Conditions.",
      "Products: All products are subject to availability. Images are illustrative; minor variations may occur in handmade and seasonal items.",
      "Pricing: All prices are in INR and inclusive of applicable taxes unless stated otherwise. We reserve the right to change prices at any time.",
      "Payments: We accept payments via Razorpay (UPI, cards, wallets, net-banking). All transactions are secure and encrypted.",
      "Bulk & Catalogue inquiries: Bulk orders, custom hampers and catalogue items are handled via WhatsApp inquiry. Final pricing and timelines are confirmed individually.",
      "Intellectual property: All content, images, designs and the Naathi Charami brand are the property of the company and protected by applicable laws.",
      "Limitation of liability: Naathi Charami Gifts & Hampers is not liable for indirect or consequential losses arising from use of the website or products.",
      "Governing law: These Terms are governed by the laws of India. Any disputes shall be subject to the exclusive jurisdiction of the courts of Hyderabad, Telangana.",
    ],
  },
};

export default function Policy() {
  const { type } = useParams();
  const policy = POLICIES[type] || POLICIES.privacy;
  return (
    <div className="pt-32 pb-20" data-testid={`policy-${type}`}>
      <div className="container-x max-w-3xl">
        <p className="label-small">Policy</p>
        <h1 className="font-serif text-5xl text-[#2D2424] mt-3">{policy.title}</h1>
        <div className="mt-10 space-y-5 text-[#5C5555] leading-relaxed">
          {policy.body.map((p, i) => <p key={i}>{p}</p>)}
        </div>
        <p className="text-sm text-[#5C5555] mt-12 italic">For any questions, write to us at naathicharami23@gmail.com or WhatsApp +91 93460 42323.</p>
      </div>
    </div>
  );
}
